"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3681],{

/***/ 9837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(4780);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(1719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(8884);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(918);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(5677);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Card/cardClasses.js

function getCardUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCard', slot);
}
const cardClasses = (0,generateUtilityClasses/* default */.Z)('MuiCard', ['root']);
/* harmony default export */ var Card_cardClasses = ((/* unused pure expression or super */ null && (cardClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Card/Card.js


const _excluded = ["className", "raised"];











const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardUtilityClass, classes);
};

const CardRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiCard',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    overflow: 'hidden'
  };
});
const Card = /*#__PURE__*/react.forwardRef(function Card(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCard'
  });

  const {
    className,
    raised = false
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    raised
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m["default"])(classes.root, className),
    elevation: raised ? 8 : undefined,
    ref: ref,
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Card_Card = (Card);

/***/ }),

/***/ 5014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CardActionArea_CardActionArea; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(4780);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(8884);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(1719);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(5677);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/CardActionArea/cardActionAreaClasses.js

function getCardActionAreaUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCardActionArea', slot);
}
const cardActionAreaClasses = (0,generateUtilityClasses/* default */.Z)('MuiCardActionArea', ['root', 'focusVisible', 'focusHighlight']);
/* harmony default export */ var CardActionArea_cardActionAreaClasses = (cardActionAreaClasses);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ButtonBase/ButtonBase.js + 6 modules
var ButtonBase = __webpack_require__(3187);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/CardActionArea/CardActionArea.js


const _excluded = ["children", "className", "focusVisibleClassName"];











const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    focusHighlight: ['focusHighlight']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardActionAreaUtilityClass, classes);
};

const CardActionAreaRoot = (0,styled/* default */.ZP)(ButtonBase/* default */.Z, {
  name: 'MuiCardActionArea',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => ({
  display: 'block',
  textAlign: 'inherit',
  width: '100%',
  [`&:hover .${CardActionArea_cardActionAreaClasses.focusHighlight}`]: {
    opacity: (theme.vars || theme).palette.action.hoverOpacity,
    '@media (hover: none)': {
      opacity: 0
    }
  },
  [`&.${CardActionArea_cardActionAreaClasses.focusVisible} .${CardActionArea_cardActionAreaClasses.focusHighlight}`]: {
    opacity: (theme.vars || theme).palette.action.focusOpacity
  }
}));
const CardActionAreaFocusHighlight = (0,styled/* default */.ZP)('span', {
  name: 'MuiCardActionArea',
  slot: 'FocusHighlight',
  overridesResolver: (props, styles) => styles.focusHighlight
})(({
  theme
}) => ({
  overflow: 'hidden',
  pointerEvents: 'none',
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: 'inherit',
  opacity: 0,
  backgroundColor: 'currentcolor',
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.short
  })
}));
const CardActionArea = /*#__PURE__*/react.forwardRef(function CardActionArea(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCardActionArea'
  });

  const {
    children,
    className,
    focusVisibleClassName
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = props;
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CardActionAreaRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m["default"])(classes.root, className),
    focusVisibleClassName: (0,clsx_m["default"])(focusVisibleClassName, classes.focusVisible),
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: [children, /*#__PURE__*/(0,jsx_runtime.jsx)(CardActionAreaFocusHighlight, {
      className: classes.focusHighlight,
      ownerState: ownerState
    })]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var CardActionArea_CardActionArea = (CardActionArea);

/***/ }),

/***/ 1359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CardContent_CardContent; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(4780);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(1719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(8884);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(5677);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/CardContent/cardContentClasses.js

function getCardContentUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCardContent', slot);
}
const cardContentClasses = (0,generateUtilityClasses/* default */.Z)('MuiCardContent', ['root']);
/* harmony default export */ var CardContent_cardContentClasses = ((/* unused pure expression or super */ null && (cardContentClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/CardContent/CardContent.js


const _excluded = ["className", "component"];









const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardContentUtilityClass, classes);
};

const CardContentRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiCardContent',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    padding: 16,
    '&:last-child': {
      paddingBottom: 24
    }
  };
});
const CardContent = /*#__PURE__*/react.forwardRef(function CardContent(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCardContent'
  });

  const {
    className,
    component = 'div'
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardContentRoot, (0,esm_extends/* default */.Z)({
    as: component,
    className: (0,clsx_m["default"])(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var CardContent_CardContent = (CardContent);

/***/ }),

/***/ 9647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CardMedia_CardMedia; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(4780);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(8884);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(1719);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(5677);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/CardMedia/cardMediaClasses.js

function getCardMediaUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCardMedia', slot);
}
const cardMediaClasses = (0,generateUtilityClasses/* default */.Z)('MuiCardMedia', ['root', 'media', 'img']);
/* harmony default export */ var CardMedia_cardMediaClasses = ((/* unused pure expression or super */ null && (cardMediaClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/CardMedia/CardMedia.js


const _excluded = ["children", "className", "component", "image", "src", "style"];










const useUtilityClasses = ownerState => {
  const {
    classes,
    isMediaComponent,
    isImageComponent
  } = ownerState;
  const slots = {
    root: ['root', isMediaComponent && 'media', isImageComponent && 'img']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardMediaUtilityClass, classes);
};

const CardMediaRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiCardMedia',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    const {
      isMediaComponent,
      isImageComponent
    } = ownerState;
    return [styles.root, isMediaComponent && styles.media, isImageComponent && styles.img];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'block',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center'
}, ownerState.isMediaComponent && {
  width: '100%'
}, ownerState.isImageComponent && {
  // ⚠️ object-fit is not supported by IE11.
  objectFit: 'cover'
}));
const MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];
const IMAGE_COMPONENTS = ['picture', 'img'];
const CardMedia = /*#__PURE__*/react.forwardRef(function CardMedia(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCardMedia'
  });

  const {
    children,
    className,
    component = 'div',
    image,
    src,
    style
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const isMediaComponent = MEDIA_COMPONENTS.indexOf(component) !== -1;
  const composedStyle = !isMediaComponent && image ? (0,esm_extends/* default */.Z)({
    backgroundImage: `url("${image}")`
  }, style) : style;

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    isMediaComponent,
    isImageComponent: IMAGE_COMPONENTS.indexOf(component) !== -1
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardMediaRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m["default"])(classes.root, className),
    as: component,
    role: !isMediaComponent && image ? 'img' : undefined,
    ref: ref,
    style: composedStyle,
    ownerState: ownerState,
    src: isMediaComponent ? image || src : undefined
  }, other, {
    children: children
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var CardMedia_CardMedia = (CardMedia);

/***/ }),

/***/ 4905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CarouselList": function() { return /* reexport */ CarouselList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowBackIos.js
var ArrowBackIos = __webpack_require__(724);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowUpward.js
var ArrowUpward = __webpack_require__(4364);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowDownward.js
var ArrowDownward = __webpack_require__(6613);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(2746);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(2097);
;// CONCATENATED MODULE: ./src/components/CarouselList/@editor/index.ts


var useEditorHandlers = function(name) {
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                type: "divider"
            },
            {
                type: "header",
                label: "Arrows"
            },
            {
                name: "theme_component_list_arrow_background_color",
                label: "Arrow background color",
                type: "color",
                default: theme.palette.secondary.main
            },
            {
                name: "theme_component_list_arrow_hover_background_color",
                label: "Arrow Hover background color",
                type: "color",
                default: theme.palette.secondary.main
            },
            {
                name: "theme_component_list_arrow_svg_color",
                label: "Arrow icon color",
                type: "color",
                default: theme.palette.common.white
            },
            {
                name: "theme_component_list_arrow_width",
                label: "Arrow width",
                type: "number",
                endAdornment: "px",
                default: 40
            },
            {
                name: "theme_component_list_arrow_min_width",
                label: "Arrow minimum width",
                type: "number",
                endAdornment: "px",
                default: 40
            },
            {
                name: "theme_component_list_arrow_height",
                label: "Arrow height",
                type: "number",
                endAdornment: "px",
                default: 40
            },
            {
                name: "theme_component_list_arrow_minimum_height",
                label: "Arrow height",
                type: "number",
                endAdornment: "px",
                default: 40
            },
            {
                type: "divider"
            },
            {
                type: "header",
                label: "Left arrow"
            },
            {
                name: "theme_component_list_arrow_left_left",
                label: "Left margin",
                type: "number",
                endAdornment: "px",
                default: 0
            },
            {
                name: "theme_component_list_arrow_left_border_radius",
                label: "Border radius",
                type: "text",
                default: "0 ".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px 0"),
                helperText: "Define as top right left bottom; e.g.: 2px 10px 5px 10px"
            },
            {
                name: "theme_component_list_arrow_left_svg_margin_left",
                label: "Icon left margin",
                type: "number",
                endAdornment: "px",
                default: theme.spacing(1)
            },
            {
                name: "theme_component_list_arrow_left_svg_font_size",
                label: "Icon size",
                type: "number",
                endAdornment: "px",
                default: theme.typography.body1.fontSize
            },
            {
                type: "divider"
            },
            {
                type: "header",
                label: "Right arrow"
            },
            {
                name: "theme_component_list_arrow_right_right",
                label: "Right margin",
                type: "number",
                endAdornment: "px",
                default: 0
            },
            {
                name: "theme_component_list_arrow_right_border_radius",
                label: "Border radius",
                type: "text",
                default: "".concat(theme.shape.borderRadius, "px 0 0 ").concat(theme.shape.borderRadius, "px"),
                helperText: "Define as top right left bottom; e.g.: 2px 10px 5px 10px"
            },
            {
                name: "theme_component_list_arrow_right_svg_margin_right",
                label: "Icon right margin",
                type: "number",
                endAdornment: "px",
                default: theme.spacing(1)
            },
            {
                name: "theme_component_list_arrow_right_svg_font_size",
                label: "Icon size",
                type: "number",
                endAdornment: "px",
                default: theme.typography.body1.fontSize
            }, 
        ],
        configuration: []
    });
};

// EXTERNAL MODULE: ./src/components/Card/index.ts + 8 modules
var Card = __webpack_require__(6267);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 4 modules
var AppContext = __webpack_require__(6242);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(1911);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 2 modules
var Button = __webpack_require__(5084);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(7120);
// EXTERNAL MODULE: ./src/components/PaperColorElevation/index.ts + 1 modules
var PaperColorElevation = __webpack_require__(830);
;// CONCATENATED MODULE: ./src/components/CarouselList/styled.tsx



// type arrowOptions = {
//   arrowOptions?: 'default' | 'circular';
// }
var Arrow = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Button/* default */.Z, {
    target: "e1qp3ttq0"
})(function(param) {
    var theme = param.theme;
    return {
        position: "absolute",
        zIndex: 1,
        top: "calc(50% - 30px)",
        width: theme.theme_component_list_arrow_width ? "".concat(theme.theme_component_list_arrow_width, "px") : "40px",
        minWidth: theme.theme_component_list_arrow_min_width ? "".concat(theme.theme_component_list_arrow_min_width, "px") : "40px",
        height: theme.theme_component_list_arrow_height ? "".concat(theme.theme_component_list_arrow_height, "px") : "auto",
        minHeight: theme.theme_component_list_arrow_minimum_height ? "".concat(theme.theme_component_list_arrow_minimum_height, "px") : "auto",
        backgroundColor: theme.theme_component_list_arrow_background_color || theme.palette.secondary.main,
        "& svg": {
            color: theme.theme_component_list_arrow_svg_color || theme.palette.common.white
        },
        hover: {
            backgroundColor: theme.theme_component_list_arrow_hover_background_color
        },
        "&.swiper-button-disabled": {
            filter: "grayscale(1)",
            cursor: "default"
        }
    };
});
var ArrowLeft = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Arrow, {
    target: "e1qp3ttq1"
})(function(param) {
    var theme = param.theme;
    return {
        left: theme.theme_component_list_arrow_left_left ? "".concat(theme.theme_component_list_arrow_left_left, "px") : 0,
        borderRadius: theme.theme_component_list_arrow_left_border_radius || "0 ".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px 0"),
        "& svg": {
            marginLeft: theme.theme_component_list_arrow_left_svg_margin_left ? "".concat(theme.theme_component_list_arrow_left_svg_margin_left, "px") : theme.spacing(1),
            fontSize: theme.theme_component_list_arrow_left_svg_font_size ? "".concat(theme.theme_component_list_arrow_left_svg_font_size, "px") : undefined
        }
    };
});
var ArrowRight = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Arrow, {
    target: "e1qp3ttq2"
})(function(param) {
    var theme = param.theme;
    return {
        right: theme.theme_component_list_arrow_right_right ? "".concat(theme.theme_component_list_arrow_right_right, "px") : 0,
        borderRadius: theme.theme_component_list_arrow_right_border_radius || "".concat(theme.shape.borderRadius, "px 0 0 ").concat(theme.shape.borderRadius, "px"),
        "& svg": {
            marginRight: theme.theme_component_list_arrow_right_svg_margin_right ? "".concat(theme.theme_component_list_arrow_right_svg_margin_right, "px") : theme.spacing(1),
            fontSize: theme.theme_component_list_arrow_right_svg_font_size ? "".concat(theme.theme_component_list_arrow_right_svg_font_size, "px") : undefined,
            transform: "rotate(180deg)"
        }
    };
});
var ArrowUp = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Arrow, {
    target: "e1qp3ttq3"
})(function(param) {
    var theme = param.theme;
    return {
        top: "12px",
        left: 0,
        right: 0,
        margin: "auto",
        borderRadius: theme.theme_component_list_arrow_left_border_radius || "0 ".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px 0"),
        "& svg": {
            fontSize: theme.theme_component_list_arrow_left_svg_font_size ? "".concat(theme.theme_component_list_arrow_left_svg_font_size, "px") : undefined
        }
    };
});
var ArrowDown = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Arrow, {
    target: "e1qp3ttq4"
})(function(param) {
    var theme = param.theme;
    return {
        bottom: 0,
        left: 0,
        right: 0,
        margin: "320px auto",
        marginBottom: 0,
        borderRadius: theme.theme_component_list_arrow_right_border_radius || "".concat(theme.shape.borderRadius, "px 0 0 ").concat(theme.shape.borderRadius, "px"),
        "& svg": {
            fontSize: theme.theme_component_list_arrow_right_svg_font_size ? "".concat(theme.theme_component_list_arrow_right_svg_font_size, "px") : undefined
        }
    };
});
var CardSkeletonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(PaperColorElevation/* PaperColorElevation */.z, {
    target: "e1qp3ttq5"
})(function(param) {
    var theme = param.theme, width = param.width, height = param.height;
    return {
        boxShadow: theme.shadows[0],
        aspectRatio: "".concat(width, "/").concat(height)
    };
});
var CarouselListContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1qp3ttq6"
})(function(param) {
    var vertical = param.vertical;
    return {
        height: vertical ? "inherit" : "100%",
        maxHeight: "100vw",
        minHeight: 0,
        minWidth: 0,
        maxWidth: "100vw",
        width: "100%",
        overflow: "hidden",
        ".swiper > .swiper-wrapper": {
            maxHeight: "100%",
            height: vertical ? "628px" : "100%",
            display: "flex"
        },
        ".swiper > .swiper-slide": {
            width: "auto",
            flexShrink: 0,
            display: "block",
            height: "100%",
            maxHeight: "100%"
        }
    };
});
var TrendSticker = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e1qp3ttq7"
})("position:absolute;top:24px;background-color:#f9484a;background-image:linear-gradient(315deg,#f9484a 0%,#fbd72b 74%);color:yellow;padding:4px 8px;border-radius:0px 0px 8px 0px;");

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Whatshot.js
var Whatshot = __webpack_require__(7089);
;// CONCATENATED MODULE: ./src/components/CarouselList/CarouselList.tsx



















var defaultBreakpoints = {
    // https://mui.com/customization/breakpoints/
    // Try to keep this similar as CollectionGrid breakpoints.
    1200: {
        // lg
        slidesPerView: 6,
        slidesPerGroup: 6
    },
    900: {
        // md
        slidesPerView: 4,
        slidesPerGroup: 4
    },
    600: {
        // sm
        slidesPerView: 3,
        slidesPerGroup: 3
    },
    0: {
        // xs
        slidesPerView: 2,
        slidesPerGroup: 2
    }
};
var CarouselList = function(props) {
    var items = props.items, className = props.className, children = props.children, padding = props.padding, cardOptions = props.cardOptions, _slidesPerView = props.slidesPerView, slidesPerView = _slidesPerView === void 0 ? 6 : _slidesPerView, _breakpoints = props.breakpoints, breakpoints = _breakpoints === void 0 ? defaultBreakpoints : _breakpoints, _direction = props.// arrowOptions,
    direction, direction = _direction === void 0 ? "horizontal" : _direction, swiperOptions = (0,_object_without_properties/* default */.Z)(props, [
        "items",
        "className",
        "children",
        "padding",
        "cardOptions",
        "slidesPerView",
        "breakpoints",
        "direction"
    ]);
    var theme = (0,useTheme/* default */.Z)();
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var assetUrl = appContext.useConfig().assetUrl;
    var channel = react.useRef(new Date().getTime().toString(36));
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(items || []), 1), slides = ref[0];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CarouselListContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className
    }, useEditorHandlers("Carousel List")), {
        vertical: direction === "vertical",
        children: [
            children,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(swiper_react/* Swiper */.tq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                style: {
                    padding: padding
                },
                id: channel === null || channel === void 0 ? void 0 : channel.current,
                modules: [
                    swiper_esm/* Navigation */.W_,
                    swiper_esm/* A11y */.s5,
                    swiper_esm/* Virtual */.eZ
                ],
                loop: true,
                slidesPerView: slidesPerView,
                spaceBetween: parseInt(theme.spacing(2).replace("px ", "")),
                breakpoints: breakpoints,
                a11y: {
                    prevSlideMessage: "Previous slide",
                    nextSlideMessage: "Next slide"
                },
                navigation: {
                    prevEl: ".arrow-left-".concat(channel === null || channel === void 0 ? void 0 : channel.current),
                    nextEl: ".arrow-right-".concat(channel === null || channel === void 0 ? void 0 : channel.current)
                },
                direction: direction || "horizontal"
            }, swiperOptions), {
                children: [
                    slides.map(function(item, index) {
                        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(swiper_react/* SwiperSlide */.o5, {
                            virtualIndex: index,
                            children: item ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Card */.Zb, (0,_object_spread/* default */.Z)({
                                        sx: {
                                            display: "flex"
                                        },
                                        href: "/game/".concat(item.slug),
                                        src: "".concat(assetUrl).concat((cardOptions === null || cardOptions === void 0 ? void 0 : cardOptions.template) === "big" ? item.images.cover4x1 || item.images.cover16x9 || item.images.cover : item.images.cover16x9 || item.images.cover, "/"),
                                        alt: item.name || "Cover",
                                        title: item.name || undefined,
                                        description: item.description || undefined
                                    }, cardOptions)),
                                    (item === null || item === void 0 ? void 0 : item.trend) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrendSticker, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Whatshot/* default */.Z, {})
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardSkeletonStyled, {
                                elevation: 1,
                                width: cardOptions.width,
                                height: cardOptions.height
                            })
                        }, "".concat(channel === null || channel === void 0 ? void 0 : channel.current).concat(index));
                    }),
                    direction === "horizontal" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowLeft, {
                                variant: "contained",
                                "aria-label": "Previous",
                                color: "secondary",
                                // arrowOptions={arrowOptions}
                                className: "arrow-left-".concat(channel.current),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowBackIos/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowRight, {
                                variant: "contained",
                                "aria-label": "Next",
                                color: "secondary",
                                // arrowOptions={arrowOptions}
                                className: "arrow-right-".concat(channel.current),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowBackIos/* default */.Z, {})
                            })
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowUp, {
                                variant: "contained",
                                "aria-label": "Previous",
                                color: "secondary",
                                // arrowOptions={arrowOptions}
                                className: "arrow-left-".concat(channel.current),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowUpward/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowDown, {
                                variant: "contained",
                                "aria-label": "Next",
                                color: "secondary",
                                // arrowOptions={arrowOptions}
                                className: "arrow-right-".concat(channel.current),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowDownward/* default */.Z, {})
                            })
                        ]
                    })
                ]
            }))
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/CarouselList/index.ts



/***/ })

}]);